export const getSelectedCorporate = (corporateId) => {
    return {
        type: "SELECTED_CORPORATE",
        payload: corporateId
    };
};